import {
    SELECT_ACTIVE_CATEGORY,
    SELECT_SORTING_TYPE,
    SET_FEED,
    SET_GAME_COMPONENT_REF,
    SET_IS_SHOW_BACK,
    SET_JACKPOT_FILTER,
    SET_PGG_GAMES,
    SET_VIEWMODE } from 'js/app/components/main/Games/store/actions';

export const defaultState = {
    listView: false,
    isShowBack: false,
    isEmptyFeed: false,
    sorting: '1',
    viewModeDetailed: true,
    feed: {},
    categories: [],
    activeCategory: {},
    gameComponentRef: null,
    dynamicCategories: [],
    jackpotOnly: false,
    pggGameList: {},
    hub2FeedName: '',
    hub2ViewMode: ''
};

export const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_VIEWMODE: {
            return {
                ...state,
                viewModeDetailed: action.payload
            };
        }
        case SET_IS_SHOW_BACK: {
            return {
                ...state,
                isShowBack: action.payload
            };
        }
        case SET_GAME_COMPONENT_REF: {
            return {
                ...state,
                gameComponentRef: action.payload
            };
        }
        case SET_JACKPOT_FILTER: {
            return {
                ...state,
                jackpotOnly: action.payload
            };
        }
        case SELECT_SORTING_TYPE: {
            return {
                ...state,
                sorting: action.payload
            };
        }
        case SELECT_ACTIVE_CATEGORY: {
            const categoryName = action.payload;
            const activeCategory = state.categories.find(cat => cat.name === categoryName);

            return {
                ...state,
                activeCategory: activeCategory || state.categories[0] || {}
            };
        }
        case SET_PGG_GAMES: {
            const pggGameList = {
                ...state.pggGameList,
                [action.payload.activeCategoryName]: { ...action.payload.pggObj }
            };

            return {
                ...state,
                pggGameList
            };
        }
        case SET_FEED: {
            return {
                ...state,
                ...action.payload
            };
        }
        default:
            return state;
    }
};
